'use strict';

import $ from 'jquery';

import sliderTemplate from './slider.html';

export const sliderDirName = 'slider';
export function sliderDir() {
  return {
    restrict: 'E',
    template: sliderTemplate,
    link: function(scope, element) {
      $(document).ready(($) => {
        /*
        $('#banner-fade').bjqs({
          height      : 410,
          width       : 1280,
          responsive  : true
        });
        */
      });
    }
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/components/slider/slider.js